import { createContext, use, type ReactNode } from 'react';

/** Onde o bloco está: tela oficial, página personalizada ou prévia (catálogo, construtor, testes). */
export type BlockSurface = 'screen' | 'page' | 'preview';

/**
 * Quem hospeda o bloco (09 §10.1). O bloco só emite intenção: a tela executa pelo manifesto, a página
 * pela `requireConfirmation` (U24). Prefira `run` com uma ação `navigate` a `navigate` com caminho.
 */
export interface BlockHost {
  readonly surface: BlockSurface;
  run(actionId: string, input: unknown): unknown;
  navigate(to: string, options?: { readonly search?: Readonly<Record<string, unknown>> }): unknown;
}

const BlockHostContext = createContext<BlockHost | null>(null);

export function BlockHostProvider({ host, children }: { readonly host: BlockHost; readonly children: ReactNode }) {
  return <BlockHostContext value={host}>{children}</BlockHostContext>;
}

/** O hospedeiro corrente. Bloco fora de um `BlockHostProvider` é erro de montagem. */
export function useBlockHost(): BlockHost {
  const host = use(BlockHostContext);
  if (!host) throw new Error('bloco renderizado sem BlockHostProvider');
  return host;
}
